/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { getEntities as getDiagLabPanels } from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import { createEntity, getEntity, reset, updateEntity } from './diag-lab-panel-item.reducer';

export const DiagLabPanelItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const diagLabPanels = useAppSelector(state => state.diagLabPanel.entities);
  const diagLabPanelItemEntity = useAppSelector(state => state.diagLabPanelItem.entity);
  const loading = useAppSelector(state => state.diagLabPanelItem.loading);
  const updating = useAppSelector(state => state.diagLabPanelItem.updating);
  const updateSuccess = useAppSelector(state => state.diagLabPanelItem.updateSuccess);

  const handleClose = () => {
    navigate(`/diag-lab-panel-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getLabTestItems({}));
    dispatch(getDiagLabPanels({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.sortOrder !== undefined && typeof values.sortOrder !== 'number') {
      values.sortOrder = Number(values.sortOrder);
    }

    const entity = {
      ...diagLabPanelItemEntity,
      ...values,
      lcTestItem: labTestItems.find(it => it.id.toString() === values.lcTestItem?.toString()),
      panel: diagLabPanels.find(it => it.id.toString() === values.panel?.toString()),
      childPanel: diagLabPanels.find(it => it.id.toString() === values.childPanel?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...diagLabPanelItemEntity,
          lcTestItem: diagLabPanelItemEntity?.lcTestItem?.id,
          panel: diagLabPanelItemEntity?.panel?.id,
          childPanel: diagLabPanelItemEntity?.childPanel?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diagLabPanelItem.home.createOrEditLabel" data-cy="DiagLabPanelItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diagLabPanelItem.home.createOrEditLabel">Create or edit a DiagLabPanelItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diag-lab-panel-item-id"
                  label={translate('tinyMedicRestApp.diagLabPanelItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabPanelItem.active')}
                id="diag-lab-panel-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabPanelItem.lastupdated')}
                id="diag-lab-panel-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabPanelItem.microSec')}
                id="diag-lab-panel-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabPanelItem.timestampentry')}
                id="diag-lab-panel-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabPanelItem.cursor')}
                id="diag-lab-panel-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabPanelItem.sortOrder')}
                id="diag-lab-panel-item-sortOrder"
                name="sortOrder"
                data-cy="sortOrder"
                type="text"
              />
              <ValidatedField
                id="diag-lab-panel-item-lcTestItem"
                name="lcTestItem"
                data-cy="lcTestItem"
                label={translate('tinyMedicRestApp.diagLabPanelItem.lcTestItem')}
                type="select"
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-panel-item-panel"
                name="panel"
                data-cy="panel"
                label={translate('tinyMedicRestApp.diagLabPanelItem.panel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-panel-item-childPanel"
                name="childPanel"
                data-cy="childPanel"
                label={translate('tinyMedicRestApp.diagLabPanelItem.childPanel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diag-lab-panel-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiagLabPanelItemUpdate;
